import { render, staticRenderFns } from "./iconPerson.vue?vue&type=template&id=f2a2c0e0&scoped=true"
import script from "./iconPerson.vue?vue&type=script&lang=js"
export * from "./iconPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2c0e0",
  null
  
)

export default component.exports